import { useViewer } from '@vimeo/viewer';

import type { CanonicalPage } from '../utils';
import { deriveCanonicalPage } from '../utils';

/**
 * Resolves the canonical page label for the current location.
 *
 * Internal helper for tracking hooks. Not exported from the package: callers
 * should not need to know about page-label resolution; the relevant tracking
 * hook injects the value into its payload automatically.
 */
export function usePageLabel(): CanonicalPage {
  const viewer = useViewer();
  if (typeof window === 'undefined') return 'unknown';
  try {
    return deriveCanonicalPage(new URL(window.location.href), {
      is_team_user: viewer?.user?.isTeamUser ?? false,
    });
  } catch {
    return 'unknown';
  }
}
